import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import Modal from "react-bootstrap/Modal";
import doneSvg from "../../../../assets/img/icons/done02.svg";
import backArrow from "../../../../assets/img/icons/blueArrow.svg";
import alertSearch from "../../../../assets/img/icons/alertSearch.svg";
import jwt_decode from "jwt-decode";
import DashboardLayout from "../../../../layout/dashboard";
import peEditorCommentTrinkaScript from "../../../../assets/js/Trinka-new-test";
import {
  acceptRejectArticle,
  downloadPeerReport,
  getPRReport,
  getReportAfterFirstRevision,
  reviewArticle,
} from "../../../../store/apiCalls/dashboard";
import { FetchProfanityList } from "../../../autherFlow/submitArticle/queries";
import { toast } from "react-toastify";
import RejectForPR from "../../../autherFlow/prdashboard/RejectForPR";
import { useSelector } from "react-redux";
import { SERVER_URL } from "../../../../config";
import {
  updatePayment,
  iniitatePayments,
} from "../../../autherFlow/submitArticle/queries";
import { UploadMedia } from "../../../../store/apiCalls/profileDetails";
import { publishFromAdminSideApi } from "../../../../store/apiCalls/articles";
import SendForRevision from "../../../autherFlow/prdashboard/SendForRevision";
import ReasonModal from "../../../autherFlow/prdashboard/ReasonModal";
import ContentDetails from "../../../../components/viewArticle/contentDetails";
import ConfirmationalModal from "../../../autherFlow/prdashboard/ConfirmationModal";
import { checkEmptyArticle, checkGrammar } from "../../../../utils";
import { useDispatch } from "react-redux";
import GrammarSpellModal from "../../../../components/Modal/GrammarSpellModal";

const SOCIETY_SPECIAL_JOURNAL = "Applied and Basic Obesity, Diabetes and Endocrinology";

const ViewReport = () => {
  const dispatch = useDispatch();
  const { id } = jwt_decode(localStorage.usertoken);
  const peEditorCommentRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const _id = location?.state?._id;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showRevisionConfirmation, setShowRevisionConfirmation] =
    useState(false);
  const [showAcceptConfirmation, setShowAcceptConfirmation] = useState(false);
  const { user } = useSelector((state) => state?.LoginReducer || {});
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentArticleId, setPaymentArticleId] = useState("");
  const [upiScreenshotUrl, setUpiScreenshotUrl] = useState("");
  const [upiTransactionId, setUpiTransactionId] = useState("");
  const [isGatewayPaymentSuccessful, setIsGatewayPaymentSuccessful] = useState(false);
  const hiddenFileInput = useRef(null);

  const copyUpiToClipboard = () => {
    navigator.clipboard.writeText("9810846333.eazypay@icici");
    toast.success("UPI ID copied to clipboard!");
  };

  const handleUploadScreenshot = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      dispatch({ type: "SET_LOADER", payload: true });
      try {
        const response = await UploadMedia(formData);
        if (response.status === 200 && response.data?.url) {
          setUpiScreenshotUrl(response.data.url);
          toast.success("Screenshot uploaded successfully!");

          const articleId = rejectionArticleId || articleData?._id || paymentArticleId || articleFlowId;
          if (articleId) {
            const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
            const payloads = {
              articleId,
              finalPayment: true,
              paymentMode: "UPI",
              status: "success",
              upiScreenshot: response.data.url,
            };
            const queryParams = { payload: payloads, headers };
            updatePaymentStatus(queryParams, {
              onSuccess: () => {
                toast.success("Offline payment details submitted successfully.");
                setShowPaymentModal(false);
              }
            });
          }
        } else {
          toast.error("Failed to upload screenshot.");
        }
      } catch (error) {
        console.error("Error uploading screenshot:", error);
        toast.error("An error occurred during upload.");
      } finally {
        dispatch({ type: "SET_LOADER", payload: false });
      }
    }
  };

  const isPaymentProofProvided = upiScreenshotUrl || upiTransactionId?.trim();

  const { mutate: updatePaymentStatus } = updatePayment();

  function updatePaymentData(response, access_key) {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    let initialPayment = false;
    let finalPayment = false;
    let totalPayment = false;
    if (response.status === "success") {
      if (response.udf2 === "intPay") initialPayment = true;
      else if (response.udf2 === "finalPay") finalPayment = true;
      else if (response.udf2 === "totalPay") totalPayment = true;
    }
    const payloads = {
      strike: true,
      currencyType: "INR",
      paymentMode: (response.card_type === "UPI" || response.card_type === "upi") ? "vkUPI" : response.card_type,
      txnid: response.txnid,
      initialPayment: initialPayment,
      finalPayment: finalPayment,
      totalPayment: totalPayment,
      articleId: response.udf1,
      data: access_key,
      mode: response.mode,
      status: response.status,
      gst: ((18 / 100) * response.amount).toFixed(2),
      payableAmount: response.net_amount_debit,
      lastPrice: response.net_amount_debit,
      typeOfPayment: response.net_amount_debit,
    };
    const queryParams = { payload: payloads, headers };
    if (response.status === "success") {
      updatePaymentStatus(queryParams, {
        onSuccess: () => {
          const articleDocId = rejectionArticleId || articleData?._id || response.udf1;
          publishFromAdminSideApi(headers, {}, articleDocId)
            .then(() => {
              window.location.href = `/manage-payment/${articleDocId}`;
            })
            .catch((err) => {
              console.error("Error publishing article:", err);
              window.location.href = `/manage-payment/${articleDocId}`;
            });
          setShowPaymentModal(false);
        },
        onError: (err) => {
          console.error("Error updating payment status:", err);
          toast.error("Failed to update payment status on server.");
        }
      });
    } else {
      updatePaymentStatus(queryParams);
      toast.error("Payment failed. Please try again.");
    }
  }

  const sucessHandlerPayment = (info) => {
    if (info.status === 200) {
      dispatch({ type: "SET_LOADER", payload: true });
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_PAYMENT_SCRIPT;
      script.onload = () => {
        dispatch({ type: "SET_LOADER", payload: false });
        var easebuzzCheckout = new window.EasebuzzCheckout(
          process.env.REACT_APP_PAYMENT_KEY,
          process.env.REACT_APP_PAYMENT_ENV
        );
        const options = {
          access_key: info.data.data.accessKey,
          onResponse: (response) => {
            updatePaymentData(response, info.data.data.accessKey);
          },
          theme: "#336d91", // color hex
        };
        easebuzzCheckout.initiatePayment(options);
      };
      document.body.appendChild(script);
    }
  };

  const { mutate: iniitatePayment } = iniitatePayments(sucessHandlerPayment);

  async function paymentInitiation(articleID) {
    // Society conference papers: INR 2999 inclusive of GST
    const amnt = isSocietyConferencePaper
      ? "2999.00"
      : (6499 * 1.18).toFixed(2).toString();
    const redairectTo = `${SERVER_URL}/dashboard`;
    const payloads = {
      key: process.env.REACT_APP_PAYMENT_KEY,
      amount: amnt,
      productinfo: "Article Publication Fee",
      firstname: user?.fullName || "User",
      phone: user?.phoneNumber || "0000000000",
      email: user?.email || "user@example.com",
      surl: `${redairectTo}`,
      furl: `${redairectTo}?type=failed`,
      salt: process.env.REACT_APP_PAYMENT_SALT,
      udf1: articleID,
      udf2: "totalPay",
      udf3: "",
      udf4: "",
      udf5: "",
      udf6: "",
      udf7: "",
      udf8: "",
      udf9: "",
      udf10: "",
      userId: id,
      articleId: articleID,
    };
    var formBody = [];
    for (var property in payloads) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(payloads[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = { payload: formBody, headers };
    iniitatePayment(queryParams);
  }

  const rejectionArticleId = location?.state?.rejectionArticleId;
  const title = location?.state?.title;
  const createdAt = location?.state?.createdAt;
  const updatedAt = location?.state?.updatedAt;
  const prData = location?.state?.prData;
  const status = location?.state?.status;
  const userType = localStorage.getItem("dropdownToggleVal") === "societyEditor" ? "Society Editor" : location?.state?.userType;
  const reasonHandle = location?.state?.reasonHandle;
  const articleStatus = location?.state?.articleStatus;
  const articleFlowId = location?.state?._id;
  const sendForRevision = location?.state?.sendForRevision;
  const [showNotAccepted, setShowNotAccepted] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [showWorkSaved, setShowWorkSaved] = useState(false);
  const [showAccept, setShowAccept] = useState(false);
  const [societyPendingPayment, setSocietyPendingPayment] = useState(false);
  const [showRevision, setShowRevision] = useState(false);
  const [articleData, setArticleData] = useState({});
  const isSocietyConferencePaper =
    (articleData?.submissionDetail?.journalType?._id || articleData?.submissionDetail?.journalType) === "6454a6390d88e62fa10503bf" &&
    (articleData?.submissionDetail?.articleType?._id || articleData?.submissionDetail?.articleType) === "664aed76ada7b4f743b760a9";
  // console.log(">>>>>>",articleData);
  const [articleReportData, setArticleReportData] = useState({});
  const [spellCheckModal, setSpellCheckModal] = useState(false);
  const [prReview, setPrReview] = useState({
    editorAssessment: "",
  });
  const [formErrors, setFormErrors] = useState({
    editorAssessment: "",
  });
  const [showAssessmentModal, setShowAssessmentModal] = useState(false);
  const [additionalComment, setAdditionalComment] = useState("");
  const [profanityWords, setProfanityWords] = useState([]);
  const [profanityWordsFound, setProfanityWordsFound] = useState([]);
  const [profanityAlert, setprofanityAlert] = useState({
    isOPen: false,
    type: 0,
  });
  const getArticleReport = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: _id,
    };
    const response = await getPRReport(headers, params);
    if (response?.status === 200) {
      if (response?.data?.success) {
        setArticleReportData(response?.data?.data?.prReview);
        setPrReview({ editorAssessment: response?.data?.data?.prReview?.editorAssessment });
      } else {
        return toast.error(response?.data?.message || "Failed to load report");
      }
    } else {
      return toast.error("Please try again!!");
    }
  };

  const getReviewArticle = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      articleId: rejectionArticleId,
    };
    const response = await reviewArticle(headers, params);
    if (response?.status === 200) {
      setArticleData(response?.data?.data);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const fetchReportAfterRevision = async (_id) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: articleFlowId,
    };
    const response = await getReportAfterFirstRevision(headers, params);
    if (response?.status === 200) {
      setArticleReportData(response?.data?.data?.[0]?.prReview);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const handleApprovePublish = async (status) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: _id,
      peStatus: status,
      peId: id,
      peApproveReasonAdditionalComment: additionalComment,
    };
    const response = await acceptRejectArticle(headers, params);
    if (response?.status === 200) {
      setShowAccept(true);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const onChangeReason = (e) => {
    setAdditionalComment(e.target.value);
  };

  const handleDownloadPeerReport = async (status) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: _id,
      peStatus: status,
      peId: id,
    };
    dispatch({ type: "SET_LOADER", payload: true });
    try {
      const response = await downloadPeerReport(headers, params);
      if (response?.status === 200 && response?.data?.downloadUrl) {
        const link = document.createElement("a");
        link.href = response.data.downloadUrl;
        link.setAttribute("target", "_blank");
        link.setAttribute("download", `peer_report_${_id}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        toast.error("Failed to download report");
      }
    } catch (error) {
      toast.error("Failed to download report");
    } finally {
      dispatch({ type: "SET_LOADER", payload: false });
    }
  };

  const validateForm = (skipProfanity = false, isReject = false) => {
    let valid = true;
    const errors = {};
    if (!isReject && !prReview?.editorAssessment) {
      errors.editorAssessment = "This field is required";
      valid = false;
    }

    if (!skipProfanity && prReview?.editorAssessment) {
      const commonDetl = prReview?.editorAssessment;
      let isProfinityWord = false;
      const profanityWordList = [];
      const cleanText = commonDetl?.replace(/(<([^>]+)>)/gi, "");
      for (var i = 0; i < profanityWords?.length; i++) {
        if (isExactMatch(cleanText?.toLowerCase(), profanityWords[i])) {
          isProfinityWord = true;
          profanityWordList?.push(profanityWords[i]);
        }
      }
      setProfanityWordsFound(profanityWordList);
      if (isProfinityWord === true) {
        valid = false;
        setprofanityAlert({ isOPen: true, type: 0 });
      }
    }

    setFormErrors(errors);
    return valid;
  };

  const saveFeedback = async (skipProfanity = false, isReject = false) => {
    let error = false;
    dispatch({ type: "SET_LOADER", payload: true });
    // const response = await checkGrammar(peEditorCommentRef.current?.value);
    dispatch({ type: "SET_LOADER", payload: false });
    // const result = response?.data?.url?.sentences;
    // result?.map((sentence) => {
    //   sentence.result?.forEach((item) => {
    //     if (
    //       (item?.cta_present?.[0] === true && (item?.error_category?.[0] === "Word/Phrase choice" && item?.error_category?.[0] === "Spellings & Typos" && item?.error_category?.[0] === "Verbs" && item?.error_category?.[0] === "Subject-verb agreement")) ||
    //       (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Word/Phrase choice") ||
    //       (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Spellings & Typos") ||
    //       (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Verbs") ||
    //       (item?.cta_present?.[0] === true && item?.error_category?.[0] === "Subject-verb agreement")
    //     ) {
    //       error = true;
    //       setSpellCheckModal(true);
    //     } else {
    //       setSpellCheckModal(false);
    //     }
    //   });
    // });
    if (error === true) {
      setSpellCheckModal(true);
      return;
    } else {
      setSpellCheckModal(false);
      if (validateForm(skipProfanity, isReject)) {
        const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
        const allParams = () => {
          const data = {
            id: _id,
            peComment: true,
            prReview: {},
          };
          if (prReview?.editorAssessment) {
            data.prReview.editorAssessment = peEditorCommentRef.current?.value;
          }
          if (articleReportData.existingLiterature) {
            data.prReview.existingLiterature = articleReportData.existingLiterature;
          }
          if (articleReportData.abstract) {
            data.prReview.abstract = articleReportData.abstract;
          }
          if (articleReportData.adequateReference) {
            data.prReview.adequateReference = articleReportData.adequateReference;
          }
          if (articleReportData.languageAcceptable) {
            data.prReview.languageAcceptable = articleReportData.languageAcceptable;
          }
          if (articleReportData.arguedAndStructured) {
            data.prReview.arguedAndStructured =
              articleReportData.arguedAndStructured;
          }
          if (articleReportData.majorChanges) {
            data.prReview.majorChanges = articleReportData.majorChanges;
          }
          if (articleReportData.strenghtsAndWeeknesses) {
            data.prReview.strenghtsAndWeeknesses =
              articleReportData.strenghtsAndWeeknesses;
          }
          if (articleReportData.recommendChanges) {
            data.prReview.recommendChanges = articleReportData.recommendChanges;
          }
          if (articleReportData.conflictOfIntrest) {
            data.prReview.conflictOfIntrest = articleReportData.conflictOfIntrest;
          }
          if (articleReportData.recommendation) {
            data.prReview.recommendation = articleReportData.recommendation;
          }
          if (articleReportData.confidentialCommentsToEditor) {
            data.prReview.confidentialCommentsToEditor =
              articleReportData.confidentialCommentsToEditor;
          }
          return data;
        };

        const response = await acceptRejectArticle(headers, allParams());
        if (response?.status === 200) {
          // setShowWorkSaved(true);
          toast.success("Report Saved successfully!");
          getArticleReport();
        } else {
          return toast.error("Please try again!!");
        }
      }
    }
  };

  const isExactMatch = (str, match) => {
    return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str);
  };
  const escapeRegExpMatch = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  };

  const handleRedirect = (e, path = "/dashboard") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = peEditorCommentTrinkaScript;
    script.id = 'peCommentTrinkaId'
    script.async = true;
    if (!document.getElementById('peCommentTrinkaId')) {
      document.body.appendChild(script);
    }
  }, [])

  useEffect(() => {
    if (articleStatus === "First Revision") {
      fetchReportAfterRevision();
      getReviewArticle();
    } else {
      getArticleReport();
      getReviewArticle();
    }
    getProfanity();
  }, []);

  const sucessHandlerProfanity = (profanity) => {
    if (profanity.status === 200) {
      setProfanityWords(profanity.data.data);
    }
  };
  async function getProfanity() {
    //
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      headers: headers,
    };

    getProfanityList(queryParams);
  }
  const { mutate: getProfanityList } = FetchProfanityList(
    sucessHandlerProfanity
  );
  return (
    <>
      <style>{`
        .approve-publish-btn {
          font-size: 20px !important;
          padding: 8px 16px !important;
          min-width: 120px !important;
          height: 50px !important;
          border-radius: 8px !important;
          font-weight: 700 !important;
          box-shadow: none !important;
        }
        @media (min-width: 992px) {
          .approve-publish-btn {
            font-size: 16px !important;
            padding: 8px 16px !important;
            border-radius: 8px !important;
          }
        }
      `}</style>
      <DashboardLayout hideSidebar={true}>
        <div className="pb-4">
          <div className="bg-white">
            <div className="viewHeader" >
              <div className="reviewHead">
                <div className="innerMergin" style={{ width: "100%" }}>
                  <h3 className="title">ARTICLE</h3>
                  {status === "approved" ||
                    status === "rejected" ||
                    status === "sentForRevision" ||
                    status === "reviewed" ||
                    articleStatus === "First Revision" ? (
                    <div>
                      <span
                        onClick={() => navigate(-1)}
                        className="button-link-gray"
                      >
                        CLOSE
                      </span>
                    </div>
                  ) : status === "peerReview" || status === "secondReview" ? (
                    <div className="reviewHeadAction">
                      <span
                        onClick={() => navigate(-1)}
                        className="button-link-gray"
                      >
                        CLOSE
                      </span>
                      <span
                        className="button-link-gray"
                        onClick={() => { handleDownloadPeerReport() }}
                      >
                        Download Report
                      </span>
                      <span
                        className="button-link-gray"
                        onClick={() => { setShowConfirmation(true); saveFeedback(false, true); }}
                      >
                        Reject to Publish
                      </span>
                      {status === "secondReview" ? null : (<>
                        {sendForRevision ? null : (
                          <span
                            className="button-link"
                            onClick={() => setShowRevisionConfirmation(true)}
                          >
                            Send for Revision
                          </span>
                        )}
                      </>)}

                      {articleData?.submissionDetail?.journalName?.trim()?.toLowerCase() !== "minorities in world politics" && (
                        <button
                          className="button button-primary approve-publish-btn"
                          style={{ marginLeft: "450px" }}
                          onClick={() => {
                            const vrJournalName = articleData?.submissionDetail?.journalName?.trim()?.toLowerCase();
                            const isMWP = (vrJournalName === "community learning and social transformation" ||
                              vrJournalName === "applied and basic obesity, diabetes and endocrinology" ||
                              vrJournalName === "applied and basic obesity, diabetes and endocrinology journal" ||
                              vrJournalName?.includes("applied and basic obesity, diabetes and endocrinology")) &&
                              (articleData?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                                articleData?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");
                            if (isMWP) {
                              setPaymentArticleId(articleFlowId);
                              setUpiScreenshotUrl("");
                              setUpiTransactionId("");
                              setIsGatewayPaymentSuccessful(false);
                              setShowPaymentModal(true);
                            } else {
                              if (!prReview?.editorAssessment?.trim()) {
                                setShowAssessmentModal(true);
                              } else {
                                setShowAcceptConfirmation(true);
                                saveFeedback();
                              }
                            }
                          }}
                        >
                          APPROVE TO PUBLISH
                        </button>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="reportLayout">
              <div className="row">
                <div className="col-md-6 reportLayoutLeft reviewArticleReport">

                  <div className="commanBox">
                    <ContentDetails
                      pagename="review-article"
                      details={{ title: "Title", desc: articleData?.title }}
                    />
                  </div>

                  <div className="commanBox">
                    <ContentDetails
                      pagename="review-article"
                      details={{
                        title: "Running Title",
                        desc: articleData?.runningTitle,
                      }}
                    />
                  </div>

                  <div className="commanBox">
                    <ContentDetails
                      pagename="review-article"
                      details={{
                        title: "Abstract",
                        desc: articleData?.abstract,
                      }}
                    />
                  </div>
                  {articleData?.articleData?.articleSection?.map(
                    (article) =>
                      checkEmptyArticle(article?.content) !== "" && (
                        <div className="commanBox">
                          <ContentDetails
                            pagename="review-article"
                            details={{
                              title: article?.title,
                              desc: article?.content,
                            }}
                          />
                        </div>
                      )
                  )}

                  {checkEmptyArticle(articleData?.articleData?.references) !==
                    "" && (
                      <div className="commanBox">
                        <ContentDetails
                          pagename="review-article"
                          details={{
                            title: "References",
                            desc: articleData?.articleData?.references,
                          }}
                        />
                      </div>
                    )}

                  {checkEmptyArticle(
                    articleData?.articleData?.acknowledgement
                  ) !== "" && (
                      <div className="commanBox">
                        <ContentDetails
                          pagename="review-article"
                          details={{
                            title: "Acknowledgements",
                            desc: articleData?.articleData?.acknowledgement,
                          }}
                        />
                      </div>
                    )}
                </div>
                <div className="col-md-6">
                  {" "}
                  <div className="reportLayoutRight">
                    <h3 className="titlePree peerReportWrap">
                      peer Review report{" "}
                      {articleReportData?.recommendation && (
                        <span style={{ color: "red", fontWeight: 700, fontSize: "18px", marginLeft: "10px", textTransform: "uppercase", textDecoration: "underline" }}>
                          {articleReportData.recommendation}
                        </span>
                      )}
                      <div className="group-button">
                        {(userType === "Publishing Editor" || userType === "Society Editor") &&
                          (status === "peerReview" || status === "secondReview") ? (
                          <button
                            className="button-link mr-2"
                            onClick={saveFeedback}
                          >
                            SAVE
                          </button>
                        ) : null}
                      </div>
                      <span
                        className="closeBtn"
                        onClick={() => navigate(-1)}
                      ></span>
                    </h3>
                    <div className="addQuestionWrap">
                      {status === "secondReview" || articleStatus === "sentForRevision" || status === "sentForRevision" || articleStatus === "sentForRevisionApproval" || articleStatus === "First Revision" ? (<>
                        <div className="editorCommaintWrap mt-3">
                          {(userType === "Publishing Editor" || userType === "Society Editor") &&
                            (status === "peerReview" || status === "secondReview") ? (
                            <div className="editorCommaint" >
                              <div className="commanTitle02">
                                {articleData?.submissionDetail?.journalType?.journalType === "Society Journal" ? "Society" : "Publishing"} Editor’s assessment <b className="red-text">*</b>
                                <em className="text-black fw-medium">(Mandatory)</em>
                              </div>
                              {/* <GrammarlyEditorPlugin> */}
                              <textarea
                                className="form-control"
                                onChange={(e) =>
                                  setPrReview({
                                    editorAssessment: e.target.value,
                                  })
                                }
                                value={
                                  prReview?.editorAssessment
                                }
                                ref={peEditorCommentRef}
                              />
                              <small className="articleFormError">
                                {formErrors?.editorAssessment && `${formErrors?.editorAssessment}`}
                              </small>
                              {/* </GrammarlyEditorPlugin> */}
                            </div>
                          ) : (userType === "Publishing Editor" ||
                            userType === "Author") &&
                            status !== "peerReview" ? (
                            <div className="editorCommaint">
                              <div className="commanTitle02">
                                {articleData?.submissionDetail?.journalType?.journalType === "Society Journal" ? "Society Editor's assessment" : "Publishing Editor's assessment"}
                              </div>
                              <span>
                                {articleReportData?.editorAssessment}
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </>) : null}
                      <div className="addQuestionTable">
                        <table>
                          <thead>
                            <tr>
                              <th className="pl-0">QUESTIONNAIRE2</th>
                              <th className="text-center">YES</th>
                              <th className="text-center">NO</th>
                              <th className="text-center">NOT APPLICABLE</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="pl-0">
                                <div className="questionTd">
                                  Does this article contribute to the existing
                                  literature on the subject?
                                </div>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="existingLiterature"
                                    checked={
                                      articleReportData?.existingLiterature ===
                                      "Yes"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="existingLanguage"
                                    checked={
                                      articleReportData?.existingLiterature ===
                                      "No"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="existingLanguage"
                                    checked={
                                      articleReportData?.existingLiterature ===
                                      "Not Applicable"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td className="pl-0">
                                <div className="questionTd">
                                  Does the Abstract (Summary) clearly and
                                  accurately describe the content of the
                                  article?
                                </div>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="abstract"
                                    checked={
                                      articleReportData?.abstract === "Yes"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="abstract"
                                    checked={
                                      articleReportData?.abstract === "No"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="abstract"
                                    checked={
                                      articleReportData?.abstract ===
                                      "Not Applicable"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td className="pl-0">
                                <div className="questionTd">
                                  Is adequate reference made to other work in
                                  the field?
                                </div>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="adequateReference"
                                    checked={
                                      articleReportData?.adequateReference ===
                                      "Yes"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="adequateReference"
                                    checked={
                                      articleReportData?.adequateReference ===
                                      "No"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="adequateReference"
                                    checked={
                                      articleReportData?.adequateReference ===
                                      "Not Applicable"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td className="pl-0">
                                <div className="questionTd">
                                  Is the language acceptable?
                                </div>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="languageAcceptable"
                                    checked={
                                      articleReportData?.languageAcceptable ===
                                      "Yes"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="languageAcceptable"
                                    checked={
                                      articleReportData?.languageAcceptable ===
                                      "No"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="customRadio">
                                  <input
                                    type="radio"
                                    name="languageAcceptable"
                                    checked={
                                      articleReportData?.languageAcceptable ===
                                      "Not Applicable"
                                    }
                                  />
                                  <b></b>
                                </label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="commanTitle02">
                        Give your Feedback here:
                      </div>
                      <>
                        <div className="questionFeedBack">
                          <p>
                            Is the article well-argued and structured? Are the
                            conclusions supported by the argument and the
                            information presented here?
                          </p>
                          <span>
                            {articleReportData?.arguedAndStructured}
                          </span>
                        </div>
                        <div className="questionFeedBack">
                          <p>
                            What are the main strengths and weaknesses of the
                            article?
                          </p>
                          <span>
                            {articleReportData?.strenghtsAndWeeknesses}
                          </span>
                        </div>
                        <div className="questionFeedBack">
                          <p>
                            Does this article need major changes? If yes,
                            please list them below.
                          </p>
                          <span>{articleReportData?.majorChanges}</span>
                        </div>
                        <div className="questionFeedBack">
                          <p>
                            Please state any conflict(s) of interest that you
                            have in relation to the review of this paper
                            (state “none” if this is not applicable).*
                          </p>
                          <span>{articleReportData?.conflictOfIntrest}</span>
                        </div>

                        <div className="commanTitle02">Recommendation</div>
                        <div className="recomArt">
                          <label className="customRadio">
                            <input
                              type="radio"
                              name="recommendation"
                              checked={
                                articleReportData?.recommendation ===
                                "ACCEPT AND PUBLISH"
                              }
                              onChange={() => setArticleReportData({ ...articleReportData, recommendation: "ACCEPT AND PUBLISH" })}
                            />
                            <b></b>
                            <span>ACCEPT AND PUBLISH</span>
                          </label>
                          <label className="customRadio">
                            <input
                              type="radio"
                              name="recommendation"
                              checked={
                                articleReportData?.recommendation ===
                                "NEEDS MAJOR REVISION"
                              }
                              onChange={() => setArticleReportData({ ...articleReportData, recommendation: "NEEDS MAJOR REVISION" })}
                            />
                            <b></b>
                            <span>NEEDS MAJOR REVISION</span>
                          </label>
                          <label className="customRadio">
                            <input
                              type="radio"
                              name="recommendation"
                              checked={
                                articleReportData?.recommendation ===
                                "REJECT FOR PUBLISHING"
                              }
                              onChange={() => setArticleReportData({ ...articleReportData, recommendation: "REJECT FOR PUBLISHING" })}
                            />
                            <b></b>
                            <span>REJECT FOR PUBLISHING</span>
                          </label>
                        </div>

                        <div className="editorCommaintWrap">
                          {userType === "Publishing Editor" || userType === "Society Editor" ? (
                            <div className="editorCommaint">
                              <div className="commanTitle02">
                                Confidential Comments to the {articleData?.submissionDetail?.journalType?.journalType === "Society Journal" ? "society" : "publishing"} Editor
                              </div>
                              <span>
                                {
                                  articleReportData?.confidentialCommentsToEditor
                                }
                              </span>
                            </div>
                          ) : userType === "Peer Reviewer" ? (
                            <div className="editorCommaint">
                              <div className="commanTitle02">
                                Confidential Comments to the editor
                              </div>
                              <span>
                                {
                                  articleReportData?.confidentialCommentsToEditor
                                }
                              </span>
                            </div>
                          ) : null}

                          {status === "secondReview" ? null : (<>
                            {(userType === "Publishing Editor" || userType === "Society Editor") &&
                              status === "peerReview" ? (
                              <div className="editorCommaint" >
                                <div className="commanTitle02">
                                  {articleData?.submissionDetail?.journalType?.journalType === "Society Journal" ? "Society" : "Publishing"} Editor’s assessment <b className="red-text">*</b>
                                  <em className="text-black fw-medium">(Mandatory)</em>
                                </div>
                                {/* <GrammarlyEditorPlugin> */}
                                <textarea
                                  className="form-control"
                                  onChange={(e) =>
                                    setPrReview({
                                      editorAssessment: e.target.value,
                                    })
                                  }
                                  value={
                                    prReview?.editorAssessment
                                  }
                                  ref={peEditorCommentRef}
                                />
                                <small className="articleFormError">
                                  {formErrors?.editorAssessment && `${formErrors?.editorAssessment}`}
                                </small>
                                {/* </GrammarlyEditorPlugin> */}
                              </div>
                            ) : (userType === "Publishing Editor" || userType === "Society Editor" ||
                              userType === "Author") &&
                              status !== "peerReview" ? (
                              <div className="editorCommaint">
                                <div className="commanTitle02">
                                  {userType === "Society Editor" ? "Society Editor's assessment" : "Publishing Editor's assessment"}
                                </div>
                                <span>
                                  {articleReportData?.editorAssessment}
                                </span>
                              </div>
                            ) : null}

                          </>)}
                        </div>
                        {/* </Grammarly> */}
                      </>
                      <div className="d-flex justify-content-end">
                        {(userType === "Publishing Editor" || userType === "Society Editor") &&
                          (status === "peerReview" || status === "secondReview") ? (
                          <button
                            className="button-link mr-3"
                            onClick={saveFeedback}
                          >
                            SAVE
                          </button>
                        ) : null}
                        <span
                          onClick={() => navigate(-1)}
                          className="button-link-gray"
                        >
                          CLOSE
                        </span>

                      </div>

                    </div>

                  </div>
                  <div style={{ right: "-45px", top: "-30px" }} className="position-relative">
                    {status === "approved" ||
                      status === "rejected" ||
                      status === "sentForRevision" ||
                      status === "reviewed" ||
                      articleStatus === "First Revision" ? (
                      <>
                      </>
                    ) : status === "peerReview" || status === "secondReview" ? (
                      <div className="reviewHeadAction d-flex align-items-center gap-4 text-uppercase justify-content-end">

                        <span
                          className="button-link-gray"
                          onClick={() => { setShowConfirmation(true); saveFeedback(false, true); }}
                        >
                          Reject to Publish
                        </span>
                        {status === "secondReview" ? null : (<>
                          {sendForRevision ? null : (
                            <span
                              className="button-link cursor-pointer"
                              onClick={() => setShowRevisionConfirmation(true)}
                            >
                              Send for Revision
                            </span>
                          )}
                        </>)}

                        {articleData?.submissionDetail?.journalName?.trim()?.toLowerCase() !== "minorities in world politics" && (
                          <button
                            className="button button-primary approve-publish-btn"
                            onClick={() => {
                              const vrJournalName2 = articleData?.submissionDetail?.journalName?.trim()?.toLowerCase();
                              const isMWP = (vrJournalName2 === "community learning and social transformation" ||
                                vrJournalName2 === "applied and basic obesity, diabetes and endocrinology" ||
                                vrJournalName2 === "applied and basic obesity, diabetes and endocrinology journal" ||
                                vrJournalName2?.includes("applied and basic obesity, diabetes and endocrinology")) &&
                                (articleData?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                                  articleData?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");
                              if (isMWP) {
                                setPaymentArticleId(articleFlowId);
                                setUpiScreenshotUrl("");
                                setUpiTransactionId("");
                                setIsGatewayPaymentSuccessful(false);
                                setShowPaymentModal(true);
                              } else {
                                if (!prReview?.editorAssessment?.trim()) {
                                  setShowAssessmentModal(true);
                                } else {
                                  setShowAcceptConfirmation(true);
                                  saveFeedback();
                                }
                              }
                            }}
                          >
                            APPROVE TO PUBLISH
                          </button>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="backBtnWrap mt-5">
                <a onClick={() => window.history.back()}>
                  <span>Back</span>
                  <img src={backArrow} alt="#" />
                </a>
              </div>
            </div>

          </div>

        </div>

      </DashboardLayout>
      <RejectForPR
        showReject={showReject}
        setShowReject={setShowReject}
        articleId={_id}
        modalTitle={"REJECT_PUBLISH"}
        peId={id}
      />
      <ConfirmationalModal
        setShowReject={setShowReject}
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        title={"Confirmation"}
        body={`<div class="text-center allGoodText"><p>Are you sure you want to reject this article to publish?</div></p>`}
        leftBtnTxt={"CONFIRM"}
        rightBtnTxt={"NO, GO BACK"}
      />
      <SendForRevision
        showRevision={showRevision}
        setShowRevision={setShowRevision}
        articleId={_id}
        rejectionArticleId={rejectionArticleId}
        peId={id}
      />
      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showRevisionConfirmation}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">CONFIRMATION</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowRevisionConfirmation(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAss">
            <p className="allGoodText text-center">
              Are you sure you want to send this article for revision?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-gray bold mr-3"
            onClick={() => {
              setShowRevisionConfirmation(false);
              setShowRevision(true);
              saveFeedback();
            }}
          >
            CONFIRM
          </span>
          <button
            class="button button-primary"
            onClick={() => setShowRevisionConfirmation(false)}
          >
            NO, GO BACK
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-md authorModal md-x"
        show={showAcceptConfirmation}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">Confirm to Publish</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowAcceptConfirmation(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAss text-center">
            <p className="allGoodText">
              Are you sure you want to approve this article to publish?
            </p>

          </div>
          <div className="rejectPr rejectModal ">
            <span><b>{userType === "Society Editor" ? "Additional Society Editor's Comment's" : "Additional Publishing Editor's Comment"} </b></span>
            <textarea
              className="inputField"
              placeholder="Please add your comment here..."
              onChange={(e) => onChangeReason(e)}
              value={additionalComment}
              maxLength={100}
            ></textarea>
            {articleData?.paymentBySociety?.finalPayment == false && "yess"}
            {articleData?.submissionDetail?.journalType?.journalType === "Society Journal" && articleData?.paymentBySociety?.apcPayBySociety && articleData?.paymentBySociety?.apcPayHaveCoupon == false && articleData?.finalPayment == false && articleData?.submissionDetail?.journalName !== SOCIETY_SPECIAL_JOURNAL ?
              <div className="mt-2">
                <p className="theme-orange-color fw-semibold f-18">After you confirm the article for publishing, <br /> you will be guided to the next step.</p>
              </div>
              : null}
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-gray bold mr-3"
            onClick={() => setShowAcceptConfirmation(false)}
          >
            CANCEL
          </span>
          {articleData?.submissionDetail?.journalType?.journalType === "Society Journal" && (articleData?.paymentBySociety?.apcPayBySociety && !articleData?.paymentBySociety?.apcPayHaveCoupon && articleData?.finalPayment == false && articleData?.submissionDetail?.journalName !== SOCIETY_SPECIAL_JOURNAL) ? <>
            <button
              class="button button-primary"
              onClick={() => {
                setSocietyPendingPayment(true);
                setShowAcceptConfirmation(false);
              }}
            >
              CONFIRM
            </button>
          </> : <>
            <button
              class="button button-primary"
              onClick={() => {
                handleApprovePublish("published");
                setShowAcceptConfirmation(false);
                setShowAccept(true);
              }}
            >
              CONFIRM
            </button>
          </>}
        </Modal.Footer>
      </Modal>
      <Modal
        dialogClassName="modal-dialog-centered modal-w-500 authorModal md-x"
        show={societyPendingPayment}
        id="congratsMobile"
        tabIndex={-1}
        className="md-x"
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">Balance APC Needs Payment</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setSocietyPendingPayment(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0 pb-0">
          <div className="">
            <p className=" text-center">
              Please pay the balance article processing charge <br /> so that the author can publish the article.
            </p>
            <p className="py-2 text-center fw-bold">
              *You have already paid the registration fee for this article
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer pb-3 pt-0">

          <button
            class="button button-primary my-2"
            onClick={() => { setSocietyPendingPayment(false), navigate("/dashboard/society-editor/payment-bypass") }}
          >
            I will Pay now

          </button>
          <div className="helpPopupText pb-0 pt-3">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-sm authorModal"
        show={showAccept}
        id="congratsMobile"
        tabIndex={-1}
      >
        <Confetti width={"450px"} height={"350px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div class="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h2 class="modal-title">Thank You</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => navigate(userType === "Society Editor" ? "/dashboard/society-editor" : "/dashboard/publishing-editor")}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAss pl-2 pr-2">
            <p className="mb-3">
              We appreciate your contribution
              <br />
              to scholarly research.
            </p>
            <p>
              The author will be notified that their article is approved for
              publication.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-active mr-3"
            onClick={() => navigate(userType === "Society Editor" ? "/dashboard/society-editor" : "/dashboard/publishing-editor")}
          >
            MY DASHBOARD
          </span>
          <button
            class="button button-primary"
            onClick={() => {
              setShowAccept(false);
              navigate(userType === "Society Editor" ? "/dashboard/society-editor" : "/dashboard/publishing-editor");
            }}
          >
            OKAY
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-sm authorModal"
        show={showAssessmentModal}
        id="assessmentModal"
        tabIndex={-1}
      >
        <Modal.Header className="modal-header">
          <h2 class="modal-title">Editor Comments Required</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowAssessmentModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="aaforAss pl-2 pr-2">
            <p className="mb-3 text-left">
              Please complete the Society Editor’s Assessment at the end of the form before submitting the editorial recommendation.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer justify-content-center">
          <button
            class="button button-primary"
            onClick={() => setShowAssessmentModal(false)}
          >
            PROCEED
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-dialog-centered modal-sm authorModal"
        show={showWorkSaved}
        id="congratsMobile"
        tabIndex={-1}
      >
        <Confetti width={"450px"} height={"350px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div class="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h2 class="modal-title pl-0 pr-0">YOUR WORK HAS BEEN SAVED</h2>
          <button
            type="button"
            class="btn-close"
            ariaLabel="Close"
            onClick={() => setShowWorkSaved(false)}
          ></button>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="aaforAssContent">
            <p>
              Find this report in the{" "}
              <Link to={userType === "Society Editor" ? "/dashboard/society-editor" : "/publishing-editor/peerReview"} state={"peerReview"}>
                <u>Peer Review</u>
              </Link>{" "}
              <br />
              section of your dashboard.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="btn-link-active mr-3"
            onClick={(e) => handleRedirect(e, userType === "Society Editor" ? "/dashboard/society-editor" : "/dashboard/publishing-editor")}
          >
            MY DASHBOARD
          </span>
          <button
            class="button button-primary"
            onClick={(e) => {
              setShowWorkSaved(false);
            }}
          >
            Continue
          </button>
        </Modal.Footer>
      </Modal>

      <ReasonModal
        showNotAccepted={showNotAccepted}
        setShowNotAccepted={setShowNotAccepted}
        reasonHandle={reasonHandle}
      />
      {/* Profanity Alert */}
      <Modal
        dialogclassName=""
        show={profanityAlert.isOPen}
        id="congratsMobile"
        tabIndex={-1}
        className={
          profanityAlert.type === 0
            ? "authorModal md-x"
            : "authorModal rightSide profanity-content-right"
        }
        centered
      >

        <Modal.Header className="modal-header">
          <div className="modal-icon">
            <img src={alertSearch} alt="#" />
          </div>
          <h5 className="modal-title">PROFANITY check Results</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={(e) => setprofanityAlert({ isOPen: false, type: 0 })}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0 pl-2 pr-2">
          <div className="grantDetails alertPopup">
            <div className="checkResultText">
              <strong>
                Thank you for sharing your assessment for this article.{" "}
              </strong>
              <p>
                Before your assessment is processed, please make sure that the
                following words are removed :
              </p>
            </div>

            <div className="offensiveBox">
              <ol>
                {profanityWordsFound.map((wrd, index) => (
                  <li>{wrd}</li>
                ))}
              </ol>
            </div>
            <div className="mt-4 mb-3 d-flex justify-content-center gap-2">
              {profanityAlert.type === 0 && (
                <>
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={(e) => setprofanityAlert({ isOPen: false, type: 0 })}
                  >
                    Make Amendments
                  </button>
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={(e) => {
                      setprofanityAlert({ isOPen: false, type: 0 });
                      saveFeedback(true);
                    }}
                  >
                    Mark as Scientific Use
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-0">
          <div className="helpPopupText pb-3">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <GrammarSpellModal
        spellCheckModal={spellCheckModal}
        setSpellCheckModal={setSpellCheckModal}
        mainContent={`Thank you for sharing your ${userType === "Society Editor" ? "Society Editor" : "Publishing Editor"} comment for submission.`}
        upperContent={"We have noticed that there are still some grammar and language issues that need your attention."}
        middleContent={`You will find them highlighted in the ${userType === "Society Editor" ? "Society Editor" : "Publishing Editor"} comment for correction.`}
        lowerContent={`Before your ${userType === "Society Editor" ? "Society Editor" : "Publishing Editor"} comment is processed, please make sure that the highlighted issues are fixed.`}
      />

      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        dialogClassName="modal-dialog-centered"
        size="lg"
      >
        <Modal.Header className="modal-header payment-modal-header">
          <h2 className="modal-title">Final Article Processing Charge Required</h2>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowPaymentModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4 payment-modal-body">
          <p style={{ fontSize: "20px", fontWeight: "500" }}><h5>Your article has been approved for publication.</h5></p>
          <p style={{ marginBottom: "20px" }}>
            To complete the final publication process, kindly pay the mandatory Article Processing Charge (APC) of: <strong>{isSocietyConferencePaper ? "INR 2999 (inclusive of 18% GST)" : "INR 6499 plus 18% GST"}</strong>
          </p>
          <div className="mb-4 d-flex justify-content-center">
            <button
              className="button button-primary view-invoice-btn"
              style={{ color: "#167092", backgroundColor: "#ffffff", borderBottom: "3px solid #167092" }}
              onClick={() => {
                window.open(`/manage-payment/${rejectionArticleId || articleData?._id}`, "_blank");
              }}
            >
              VIEW INVOICE
            </button>
          </div>
          <hr />
          <h5 style={{ marginTop: "20px" }}>Payment Method 1 — Payment Gateway</h5>
          <p style={{ paddingBottom: "15px", paddingTop: "20px" }}>
            If you prefer to pay using Debit Card, Credit Card, Net Banking, or International Payment methods, you may proceed through the secure Payment Gateway.
          </p>
          <div className="mb-4 d-flex justify-content-center">
            <button
              className="button-border button-border-hover-red"
              onClick={() => {
                if (paymentArticleId) {
                  const articleDocId = rejectionArticleId || articleData?._id;
                  paymentInitiation(articleDocId);
                }
              }}
            >
              Proceed to Payment Gateway
            </button>
          </div>
          <hr />
          <h5 style={{ marginTop: "20px", marginBottom: "10px" }}>Payment Method 2 — Direct UPI Payment</h5>
          <p style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            Please make the payment using the following UPI ID:<br />
            <strong>9810846333.eazypay@icici</strong>
            <i
              className="fa fa-copy ms-2 cursor-pointer"
              style={{ cursor: "pointer", color: "#336d91" }}
              onClick={copyUpiToClipboard}
              title="Copy UPI ID"
            ></i>
          </p>
          <p style={{ paddingBottom: "10px" }}>
            After completing the payment, kindly upload the payment screenshot or enter the transaction reference number below for verification.
          </p>
          <div className="mb-3 d-flex flex-column align-items-center">
            <button
              className="button-border button-border-hover-red"
              onClick={() => hiddenFileInput.current?.click()}
            >
              {upiScreenshotUrl ? "Revise Payment Screenshot" : "Upload Payment Screenshot"}
            </button>
            <input
              type="file"
              hidden
              ref={hiddenFileInput}
              onChange={handleUploadScreenshot}
              accept="image/*"
            />
            {upiScreenshotUrl && (
              <div className="mt-2 d-flex flex-column align-items-center">
                <div className="text-success mb-2">
                  <i className="icon-check me-1"></i> Screenshot uploaded successfully
                </div>
                <div className="position-relative" style={{ display: "inline-block", width: "120px", height: "120px", border: "1px solid #ccc", borderRadius: "5px", padding: "5px", backgroundColor: "#f9f9f9" }}>
                  <img
                    src={upiScreenshotUrl}
                    alt="Payment Screenshot"
                    style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
                    onClick={() => window.open(upiScreenshotUrl, "_blank")}
                    title="Click to view full size"
                  />
                  <button
                    type="button"
                    style={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      width: "20px",
                      height: "20px",
                      padding: "0",
                      fontSize: "12px",
                      lineHeight: "1",
                      backgroundColor: "#ff4d4f",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() => setUpiScreenshotUrl("")}
                    title="Remove image"
                  >
                    &times;
                  </button>
                </div>
              </div>
            )}
          </div>
          <p style={{ paddingTop: "20px", paddingBottom: "20px", textAlign: "center" }}>OR</p>
          <div className="mb-4 d-flex flex-column align-items-center">
            <label style={{ fontSize: "16px", fontWeight: "bold", paddingBottom: "10px", textAlign: "center" }}>Transaction Reference ID</label>
            <input
              type="text"
              className="form-control mt-1 text-center"
              style={{ maxWidth: "300px" }}
              placeholder="Type here..."
              value={upiTransactionId}
              onChange={(e) => setUpiTransactionId(e.target.value)}
            />
          </div>
          <p className="mandatory-blink-text">Please upload payment screenshot or reference id for confirmation. This is a mandatory step.</p>
          <hr />
          <h5>Note</h5>
          <p>
            The article will be published once the <b>UPI PAYMENT</b> is successfully verified by the publishing team. Thank you for publishing with Aakashganga Open.
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewReport;
